import { render } from "./GamificationLeaderboardWeekly.vue?vue&type=template&id=7c25000e"
import script from "./GamificationLeaderboardWeekly.vue?vue&type=script&lang=js"
export * from "./GamificationLeaderboardWeekly.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__